// src/views/UsuariosListado.jsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { listarUsuarios, eliminarUsuario } from "../api";
import "./UsuariosListado.css";

export default function UsuariosListado() {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [busqueda, setBusqueda] = useState("");
  const [roleFilter, setRoleFilter] = useState("");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const navigate = useNavigate();

  const pageSize = 20;
  const totalPages = total === 0 ? 1 : Math.ceil(total / pageSize);

  const load = async () => {
    try {
      setLoading(true);
      const { items, total } = await listarUsuarios({
        page,
        page_size: pageSize,
        q: busqueda,
        role: roleFilter,
      });
      setUsuarios(items);
      setTotal(total);
      setError("");
    } catch (e) {
      console.error(e);
      setError(e.message || "Error al cargar usuarios");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, roleFilter]);

  const handleBuscar = (e) => {
    e.preventDefault();
    setPage(1);
    load();
  };

  const handleEliminar = async (id) => {
    if (!window.confirm("¿Seguro que quieres eliminar este usuario?")) return;
    try {
      await eliminarUsuario(id);
      setUsuarios((prev) => prev.filter((u) => u.id !== id));
      setTotal((t) => Math.max(0, t - 1));
    } catch (e) {
      alert(e.message || "Error al eliminar usuario");
    }
  };

  const handleEditar = (u) => {
    // Ahora navegamos a la vista de edición
    navigate(`/admin/usuarios/${u.id}`);
  };

  return (
    <div className="usuarios-listado">
      <form className="usuarios-filtros" onSubmit={handleBuscar}>
        <input
          type="text"
          placeholder="Buscar por nombre, email, DNI..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
        />
        <select
          value={roleFilter}
          onChange={(e) => {
            setRoleFilter(e.target.value);
            setPage(1);
          }}
        >
          <option value="">Todos los roles</option>
          <option value="psicologa">Psicóloga</option>
          <option value="psicologa-adultos">Psicóloga adultos</option>
          <option value="logopeda">Logopeda</option>
          <option value="nutricionista">Nutricionista</option>
          <option value="admin">Admin</option>
        </select>
        <button type="submit">Buscar</button>
      </form>

      {loading && <p>Cargando usuarios...</p>}
      {error && <p className="usuarios-error">{error}</p>}

      {!loading && !error && (
        <>
          <p className="usuarios-resumen">
            Total: <strong>{total}</strong> usuarios
          </p>

          {usuarios.length === 0 ? (
            <p>No hay usuarios que coincidan con la búsqueda.</p>
          ) : (
            <div className="usuarios-table-wrapper">
              <table className="usuarios-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Nombre</th>
                    <th>Email</th>
                    <th>DNI</th>
                    <th>Colegiado</th>
                    <th>Rol</th>
                    <th>% Prof.</th>
                    <th>Creado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {usuarios.map((u) => (
                    <tr key={u.id}>
                      <td>{u.id}</td>
                      <td>
                        <button
                          type="button"
                          className="usuarios-nombre-link"
                          onClick={() => handleEditar(u)}
                        >
                          {u.nombre}
                        </button>
                      </td>
                      <td>{u.email}</td>
                      <td>{u.dni || "—"}</td>
                      <td>{u.colegiado || "—"}</td>
                      <td>{u.role}</td>
                      <td>
                        {u.porcentaje_profesional != null
                          ? `${u.porcentaje_profesional}%`
                          : "—"}
                      </td>
                      <td>
                        {u.created_at
                          ? new Date(u.created_at).toLocaleDateString("es-ES")
                          : "—"}
                      </td>
                      <td className="usuarios-acciones">
                        <button
                          type="button"
                          className="btn-accion btn-editar"
                          onClick={() => handleEditar(u)}
                          title="Editar usuario"
                        >
                          <i className="fa-solid fa-pen"></i>
                        </button>
                        <button
                          type="button"
                          className="btn-accion btn-eliminar"
                          onClick={() => handleEliminar(u.id)}
                          title="Eliminar usuario"
                        >
                          <i className="fa-solid fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {totalPages > 1 && (
            <div className="usuarios-paginacion">
              <button
                type="button"
                onClick={() => setPage((p) => Math.max(1, p - 1))}
                disabled={page === 1}
              >
                ← Anterior
              </button>
              <span>
                Página {page} de {totalPages}
              </span>
              <button
                type="button"
                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                disabled={page === totalPages}
              >
                Siguiente →
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
